import { render, staticRenderFns } from "./marketplace-highlights-carousel.component.vue?vue&type=template&id=187c349d"
import script from "./marketplace-highlights-carousel.component.vue?vue&type=script&lang=js"
export * from "./marketplace-highlights-carousel.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports